import { lazy } from 'react';
import { Navigate, useParams } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RoleGuard from './RoleGuard';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// ABM
// Entity
const NewEntity = Loadable(lazy(() => import('views/diiot/abm/entity/newEntity')));
const ModifyEntity = Loadable(lazy(() => import('views/diiot/abm/entity/modifyEntity')));
const ConfEntity = Loadable(lazy(() => import('views/diiot/abm/entity/entityConf')));

// Location
const NewLocation = Loadable(lazy(() => import('views/diiot/abm/location/newLocation')));
const ModifyLocation = Loadable(lazy(() => import('views/diiot/abm/location/modifyLocation')));
const ConfLocation = Loadable(lazy(() => import('views/diiot/abm/location/locationConf')));

// Device
const NewDevice = Loadable(lazy(() => import('views/diiot/abm/device/newDevice')));
const ModifyDevice = Loadable(lazy(() => import('views/diiot/abm/device/modifyDevice')));
const ConfDevice = Loadable(lazy(() => import('views/diiot/abm/device/deviceConf')));
const UserProfile = Loadable(lazy(() => import('views/diiot/user/profile')));
const AdminOverview = Loadable(lazy(() => import('views/diiot/admin/overview')));
const AdminDevices = Loadable(lazy(() => import('views/diiot/admin/devices')));
const AdminReports = Loadable(lazy(() => import('views/diiot/admin/reports')));
const AdminUsers = Loadable(lazy(() => import('views/diiot/admin/users')));
// const AdminIotTools = Loadable(lazy(() => import('views/diiot/admin/iot-tools'))); // deshabilitada temporalmente

const LegacyModifyDatapointRedirect = () => {
  const { deviceCode } = useParams();
  return <Navigate to={`/datapoint/modificarDatapoint/${deviceCode}`} replace />;
};

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'entidad',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
        {
          path: 'nuevaEntidad',
          element: (
            <RoleGuard allowedRoles={['System admin', 'User']}>
              <NewEntity />
            </RoleGuard>
          )
        },
        {
          path: 'modificarEntidad/:entityId',
          element: (
            <RoleGuard>
              <ModifyEntity />
            </RoleGuard>
          )
        },
        {
          path: 'configuracion',
          element: (
            <RoleGuard>
              <ConfEntity />
            </RoleGuard>
          )
        }
      ]
    },
    {
      path: 'locacion',
      children: [
        {
          path: 'nuevaLocacion',
          element: (
            <RoleGuard>
              <NewLocation />
            </RoleGuard>
          )
        },
        {
          path: 'modificarLocacion/:locationId',
          element: (
            <RoleGuard>
              <ModifyLocation />
            </RoleGuard>
          )
        },
        {
          path: 'configuracion',
          element: (
            <RoleGuard>
              <ConfLocation />
            </RoleGuard>
          )
        }
      ]
    },
    {
      path: 'datapoint',
      children: [
        {
          path: 'nuevoDatapoint',
          element: (
            <RoleGuard>
              <NewDevice />
            </RoleGuard>
          )
        },
        {
          path: 'modificarDatapoint/:deviceCode',
          element: (
            <RoleGuard>
              <ModifyDevice />
            </RoleGuard>
          )
        },
        {
          path: 'configuracion',
          element: (
            <RoleGuard>
              <ConfDevice />
            </RoleGuard>
          )
        }
      ]
    },
    {
      path: 'dispositivo',
      children: [
        {
          path: 'nuevoDispositivo',
          element: <Navigate to="/datapoint/nuevoDatapoint" replace />
        },
        {
          path: 'modificarDispositivo/:deviceCode',
          element: <LegacyModifyDatapointRedirect />
        },
        {
          path: 'configuracion',
          element: <Navigate to="/datapoint/configuracion" replace />
        },
        {
          path: '*',
          element: <Navigate to="/datapoint/configuracion" replace />
        }
      ]
    },
    {
      path: 'usuario',
      children: [
        {
          path: 'perfil',
          element: (
            <RoleGuard>
              <UserProfile />
            </RoleGuard>
          )
        }
      ]
    },
    {
      path: 'admin',
      children: [
        {
          path: 'resumen',
          element: (
            <RoleGuard allowedRoles={['System admin']}>
              <AdminOverview />
            </RoleGuard>
          )
        },
        {
          path: 'dispositivos',
          element: (
            <RoleGuard allowedRoles={['System admin']}>
              <AdminDevices />
            </RoleGuard>
          )
        },
        {
          path: 'reportes',
          element: (
            <RoleGuard allowedRoles={['System admin']}>
              <AdminReports />
            </RoleGuard>
          )
        },
        {
          path: 'usuarios',
          element: (
            <RoleGuard allowedRoles={['System admin']}>
              <AdminUsers />
            </RoleGuard>
          )
        }
        // Herramientas IoT deshabilitada temporalmente. Para reactivar: descomentar esta ruta, el import
        // de AdminIotTools y el item en menu-items/admin.js.
        // ,{
        //   path: 'herramientas-iot',
        //   element: (
        //     <RoleGuard allowedRoles={['System admin']}>
        //       <AdminIotTools />
        //     </RoleGuard>
        //   )
        // }
      ]
    }
  ]
};

export default MainRoutes;
